
<!-- Header that allows for selecting the Infrastructure subpage to be on -->
<app-infrastructure-header [title]='"ZONES"'></app-infrastructure-header>

<!-- Main Screen which shows the Zones and Zone Instances -->
<div style="clear: both" id="objectContentPane">
	<div style="margin: 12px">

		<!-- Tab Navigation Control -->
		<ul class="nav nav-tabs">
			<li class="active"><a data-toggle="tab" href="#zone-instances-tab" aria-expanded="true"><i class="fa fa-star-o"></i> ZONES</a></li>
			<li class=""><a data-toggle="tab" href="#zones-tab" aria-expanded="false"><i class="fa fa-star-o"></i> ZONE TYPES</a></li>
		</ul>

		<!-- Tab Content -->
		<div class="tab-content">

			<!-- Zones Tab -->
			<div id="zones-tab" class="tab-pane fade">

				<!-- Add Zone Type and Options buttons -->
				<button (click)="addZoneClicked()" type="button" class="btn btn-ef"><em class="fa fa-plus"></em> ADD
					ZONE TYPE</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedZoneClicked()" [class.disabled]="!isSingleZoneSelected()"><a><em
									class="fa fa-pencil"></em> EDIT</a></li>
						<li (click)="duplicateSelectedZoneClicked()" [class.disabled]="!isSingleZoneSelected()"><a><em
									class="fa fa-clone"></em> DUPLICATE</a></li>
						<li (click)="deleteSelectedZonesClicked()" [class.disabled]="!isAnyZonesSelected()"><a><em
									class="fa fa-remove"></em> DELETE</a></li>
						<li class="divider"></li>
						<li (click)="addSelectedZonesToGroupClicked()" [class.disabled]="!isAnyZonesSelected()"><a><em
									class="fa fa-plus"></em> ADD TO GROUP</a></li>
						<li (click)="removeSelectedZonesFromGroupClicked()" [class.disabled]="!isAnyZonesSelected()">
							<a><em class="fa fa-remove"></em> REMOVE FROM GROUP</a></li>
						<li (click)="manageZoneGroupsClicked()"><a><em class="fa fa-pencil"></em> MANAGE GROUPS</a></li>
					</ul>
				</div>

				<!-- "Filter" button w/ drop down options -->
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
						<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
					</button>
					<ul class="dropdown-menu">
						<li *ngFor="let filterOption of filterOptionForZones" (click)="onFilterOptionForZoneClicked(filterOption)">
							<a>{{ filterOption.label }}</a>
						</li>
					</ul>
				</div>

				<!-- Filter Label (if a Filter Option is selected) -->
				<div *ngIf="selectedFilterOptionForZone?.column != null" 
					class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					{{ selectedFilterOptionForZone.label }}
				</div>

				<!-- Filter Value (if a Filter Option is selected)-->
				<div *ngIf="selectedFilterOptionForZone?.column != null" 
					class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<input class="form-control ng-pristine ng-valid ng-untouched" type="text"
						[(ngModel)]="filterOptionValueForZone"
						(ngModelChange)="onFilterValueForZoneChanged()">
				</div>

				<!-- Results Per Page -->
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
							<ul class="dropdown-menu">
								<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForType(value)" [class.active]="value === selectedPageSizeValueForTypes">
									<a>{{ value }}</a>
								</li>
							</ul>
				</div>

				<!-- Zones -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table1"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllZonesSelected()"
										(change)="setAllZonesSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container *ngFor="let zone of mZones | paginate: {id: 'zone_pagination', itemsPerPage: selectedPageSizeValueForTypes, currentPage: currentPageForZones, totalItems: totalNumberOfZones }">
							<tr class="" role="row">
								<td><input type="checkbox" [(ngModel)]="zone.mSelected" /></td>
								<td (click)="editZone(zone.mZone)">{{zone.mZone.name}}</td>
								<td>
									<ng-container *ngIf="zone.mZone.groups != null && zone.mZone.groups.length > 0">
										<ng-container *ngFor="let group of zone.mZone.groups">
											<button (click)="showGroup(group)"
												class="groupButton">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<pagination-controls class="pagination" id="zone_pagination" (pageChange)="pageChangedZone($event)"
					[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
				</pagination-controls>

			</div>

			<!-- Zone Instances Tab -->
			<div id="zone-instances-tab" class="tab-pane fade active in">

				<!-- Add Zone and Options buttons -->
				<button (click)="addZoneInstanceClicked()" type="button" class="btn btn-ef"><em class="fa fa-plus"></em>
					ADD ZONE</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedZoneInstanceClicked()"
							[class.disabled]="!isSingleZoneInstanceSelected()"><a><em class="fa fa-pencil"></em>
								EDIT</a></li>
						<li (click)="duplicateSelectedZoneInstanceClicked()"
							[class.disabled]="!isSingleZoneInstanceSelected()"><a><em class="fa fa-clone"></em>
								DUPLICATE</a></li>
						<li (click)="deleteSelectedZoneInstancesClicked()"
							[class.disabled]="!isAnyZoneInstancesSelected()"><a><em class="fa fa-remove"></em>
								DELETE</a></li>
						<li class="divider"></li>
						<li (click)="addSelectedZoneInstancesToGroupClicked()"
							[class.disabled]="!isAnyZoneInstancesSelected()"><a><em class="fa fa-plus"></em> ADD TO
								GROUP</a></li>
						<li (click)="removeSelectedZoneInstancesFromGroupClicked()"
							[class.disabled]="!isAnyZoneInstancesSelected()"><a><em class="fa fa-remove"></em> REMOVE
								FROM GROUP</a></li>
						<li (click)="manageZoneInstanceGroupsClicked()"><a><em class="fa fa-pencil"></em> MANAGE
								GROUPS</a></li>
					</ul>
				</div>

				<!-- "Filter" button w/ drop down options -->
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
						<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
					</button>
					<ul class="dropdown-menu">
						<li *ngFor="let filterOption of filterOptionForZoneInstances" (click)="onFilterOptionForZoneInstanceClicked(filterOption)">
							<a>{{ filterOption.label }}</a>
						</li>
					</ul>
				</div>

				<!-- Filter Label (if a Filter Option is selected) -->
				<div *ngIf="selectedFilterOptionForZoneInstance?.column != null" 
					class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					{{ selectedFilterOptionForZoneInstance.label }}
				</div>

				<!-- Filter Value (if a Filter Option is selected)-->
				<div *ngIf="selectedFilterOptionForZoneInstance?.column != null" 
					class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<input class="form-control ng-pristine ng-valid ng-untouched" type="text"
						[(ngModel)]="filterOptionValueForZoneInstance"
						(ngModelChange)="onFilterValueForZoneInstanceChanged()">
				</div>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
							<ul class="dropdown-menu">
								<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForInstance(value)" [class.active]="value === selectedPageSizeValueForInstances">
									<a>{{ value }}</a>
								</li>
							</ul>
				</div>
				<!-- Zone Instances -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table2"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllZoneInstancesSelected()"
										(change)="setAllZoneInstancesSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="object" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Asset Type: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Zone Type</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="3" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container *ngFor="let zoneInstance of mZoneInstances | paginate: {id: 'zoneinstance_pagination', itemsPerPage: selectedPageSizeValueForInstances, currentPage:  currentPageForZoneInstances, totalItems: totalNumberOfZoneInstances}">
							<tr class="" role="row">
								<td><input type="checkbox" [(ngModel)]="zoneInstance.mSelected" /></td>
								<td (click)="editZoneInstance(zoneInstance.mZoneInstance)"  (contextmenu)="fetchFunctionList($event, zoneInstance.mZoneInstance)">
									{{zoneInstance.mZoneInstance.name}}</td>
								<td (click)="editZoneInstance(zoneInstance.mZoneInstance)">
									{{zoneInstance.mZoneInstance.zone.name}}</td>
								<td>
									<ng-container
										*ngIf="zoneInstance.mZoneInstance.groups != null && zoneInstance.mZoneInstance.groups.length > 0">
										<ng-container *ngFor="let group of zoneInstance.mZoneInstance.groups">
											<button (click)="showGroup(group)"
												class="groupButton">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<pagination-controls
				   class="pagination"
				   id="zoneinstance_pagination"
                   (pageChange)="pageChangedZoneInstance($event)"
                   [directionLinks]="true"
                   nextLabel="Next"
                   previousLabel="Prev"
                   [autoHide]="true">
        </pagination-controls>

			</div>
		</div>
	</div>
</div>

<app-entity-type-dialog #entityTypeDialog [entity]="mEntity" [entityName]="mEntityName" [entityType]="mEntityType"
	[entityTypeName]="mEntityTypeName" (createOrUpdateEvent)="createOrUpdateEntityType()"
	(showGroup)="showGroup($event)">
</app-entity-type-dialog>

<app-entity-instance-dialog #entityInstanceDialog [instance]="mInstance" 
	[instanceName]="mInstanceName" [instanceEntityType]="mInstanceEntityType" [instanceType]="mInstanceType"
	[instanceTypeName]="mInstanceTypeName" [availableEntityTypes]="mAvailableEntityTypes"
	[selectedLocation]="mSelectedLocation" [availableLocations]="mAvailableLocations"
	(createOrUpdateEvent)="createOrUpdateEntityInstance()" (showGroup)="showGroup($event)"
	(selectedEntityTypeChangedEvent)="selectedEntityTypeChanged($event)"
	(refreshInstanceDataEvent)="refreshInstanceData()" (selectedLocationChangedEvent)="selectedLocationChanged($event)">
</app-entity-instance-dialog>

<app-confirm-delete-dialog #confirmDeleteDialog (confirmEvent)="deleteConfirmed()"></app-confirm-delete-dialog>
<app-show-group-dialog #showGroupDialog></app-show-group-dialog>
<app-manage-groups-dialog #manageGroupsDialog></app-manage-groups-dialog>
<app-add-to-group-dialog #addToGroupDialog (confirmEvent)="addSelectedToGroup($event)"></app-add-to-group-dialog>
<app-remove-from-group-dialog #removeFromGroupDialog (confirmEvent)="removeSelectedFromGroup($event)">
</app-remove-from-group-dialog>

<!-- Right Click dropdown menu -->
<app-dropdown-menu *ngIf="showContextMenu" [x]="contextMenuPosition.x" [y]="contextMenuPosition.y"
	[items]="functionList" (selectedItemChange)="onItemClicked($event)"></app-dropdown-menu>

<!-- Going further if we want to display the function execution status
	<app-function-executing-dialog  #functionExecutingDialog (functionExecutionStartEvent)="functionStartingToExecute($event)" (functionExecutionSuccessEvent)="functionFinishedExecutingSuccessfully()" (functionExecutionErrorEvent)="functionFinishedExecutingWithError($event)"></app-function-executing-dialog> -->

<app-general-function-dialog *ngIf="showGeneralDialog" #generalDialog [instance]="mInstance"
	[instanceType]="mInstanceType" [function]="selectedFunction"></app-general-function-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>